import { render } from "./rke2.vue?vue&type=template&id=0fa427a8&scoped=true"
import script from "./rke2.vue?vue&type=script&lang=js"
export * from "./rke2.vue?vue&type=script&lang=js"

import "./rke2.vue?vue&type=style&index=0&id=0fa427a8&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0fa427a8"]])

export default __exports__